'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { PAYMENT_TYPES } from 'my-purchases/constants/paymentTypes'
import type { OrderDetails } from 'my-purchases/types/purchaseDetail'

import styles from './PurchasePaymentInfo.module.scss'

interface PurchasePaymentInfoProps {
	readonly order: OrderDetails
}

export function PurchasePaymentInfo({ order }: PurchasePaymentInfoProps) {
	const { t } = useLabels()

	const { payment } = order
	const { type, number } = payment ?? {}
	return (
		<div className={styles.container}>
			<div>
				<p>
					{`${t('myPurchases.store.details.paymentDetails.method.text')} ${
						type === PAYMENT_TYPES.card
							? t('my_purchases.receipt.details.card')
							: t('my_purchases.receipt.details.cash')
					}`}
				</p>
				{number && (
					<p>
						{`${t(
							'myPurchases.store.details.paymentDetails.cardNumber.text'
						)} ${number}`}
					</p>
				)}
			</div>
		</div>
	)
}
